















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Company } from '@/utils/Interfaces'

@Component
export default class NavDrawerNhapLieuListItem extends Vue {
  @Prop(Array) readonly companies!: Array<Company>
}
